import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Resources from "./pages/Resources";
import CAD from "./pages/CAD";
import ConversationalAIChatbotDevelopment from "./pages/ConversationalAIChatbotDevelopment";
import VAPT from "./pages/VAPT";
import MobileAppPentesting from "./pages/MobileAppPentesting";
import CloudConsulting from "./pages/CloudConsulting";
import CloudImplementationService from "./pages/CloudImplementationService";
import AIAndMLConsulting from "./pages/AIAndMLConsulting";
import TechAdvisoryConsulting from "./pages/TechAdvisoryConsulting";
import TechStackAsAService from "./pages/TechStackAsAService";
import CorporateSecurityAwarenessTraining from "./pages/CorporateSecurityAwarenessTraining";
import DataAnalysis from "./pages/DataAnalysis";
import BlockchainDevelopmentServices from "./pages/BlockchainDevelopmentServices";
import Footer from "./components/Footer";  
import TeamSection from "./pages/Teampage";
import useScrollRestoration from './components/useScrollRestoration';
import OurPartners from "./pages/OurPartners";
import Loader from "./components/Loader"; // Import your Loader component

function MainContent() {
  useScrollRestoration(); // Using the custom hook for scroll restoration

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/products" element={<Products />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/CAD" element={<CAD />} />
      <Route path="/ConversationalAIChatbotDevelopment" element={<ConversationalAIChatbotDevelopment />} />
      <Route path="/VAPT" element={<VAPT />} />
      <Route path="/MobileAppPentesting" element={<MobileAppPentesting />} />
      <Route path="/CloudConsulting" element={<CloudConsulting />} />
      <Route path="/CloudImplementationService" element={<CloudImplementationService />} />
      <Route path="/AIAndMLConsulting" element={<AIAndMLConsulting />} />
      <Route path="/TechAdvisoryConsulting" element={<TechAdvisoryConsulting />} />
      <Route path="/TechStackAsAService" element={<TechStackAsAService />} />
      <Route path="/CorporateSecurityAwarenessTraining" element={<CorporateSecurityAwarenessTraining />} />
      <Route path="/DataAnalysis" element={<DataAnalysis />} />
      <Route path="/BlockchainDevelopmentServices" element={<BlockchainDevelopmentServices />} />
      <Route path="/TeamSection" element={<TeamSection />} />
      <Route path="/our-partners" element={<OurPartners />} />
    </Routes>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay (e.g., 3 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    // Cleanup timer if component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MainContent />
          <Footer />
        </>
      )}
    </Router>
  );
}

export default App;
